import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import Image from '../image/Image';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';
import * as classes from './Card.module.css';
import CloseIcon from '../../assets/icons/inline/close.svg';

const Card = ({
  image = 'default',
  title,
  date = null,
  text = '',
  extra,
  actions = null,
  flagText = null,
  locale = 'en-US',
}) => {
  const [more, setMore] = useState(false);
  const dateElement = date ? <h3>{date}</h3> : null;
  const flagTextElement = flagText ? <h4>{flagText}</h4> : null;

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return <p style={{ fontSize: '1rem' }}>{children}</p>;
      },
      [BLOCKS.HEADING_1]: (node, children) => {
        return <h1>{children}</h1>;
      },
      [BLOCKS.HEADING_2]: (node, children) => {
        return <h2>{children}</h2>;
      },
      [BLOCKS.HEADING_3]: (node, children) => {
        return <h3>{children}</h3>;
      },
      [BLOCKS.HEADING_4]: (node, children) => {
        return <h4>{children}</h4>;
      },
      [BLOCKS.HEADING_5]: (node, children) => {
        return <h5>{children}</h5>;
      },
      [BLOCKS.HEADING_6]: (node, children) => {
        return <h3>{children}</h3>;
      },
    },
  };

  const showMore = {
    'en-US': 'Show more',
    fi: 'Näytä lisää',
  };

  const activateAction = (buttonLink, bookingType) => {
    if (buttonLink !== null) {
      if (buttonLink.includes('mailto')) {
        const mailtoLink = buttonLink + '?subject=' + bookingType;
        window.open(mailtoLink, 'Booking email');
      } else if (
        buttonLink.includes('http://') ||
        buttonLink.includes('https://')
      ) {
        window.open(buttonLink);
      } else if (
        !buttonLink.includes('http://') &&
        !buttonLink.includes('https://')
      ) {
        window.location.href = buttonLink;
      }
    }
  };

  return (
    <div className={classes.card}>
      <div className={classes.wrapper}>
        <Image image={image} card />
        {more ? (
          <div className={`${classes.content} ${classes.fixedWidth}`}>
            <button
              className={classes.closeButton}
              onClick={() => setMore(false)}
            >
              <img src={CloseIcon} alt="close icon" />
            </button>
            <div className={classes.extra}>
              {renderRichText(extra, options)}
            </div>
          </div>
        ) : (
          <div
            className={`${classes.content} ${extra ? classes.fixedWidth : ''}`}
          >
            <h2>{title}</h2>
            {dateElement}
            <div className={classes.text}>
              {text && (
                <>
                  <p>{text}</p>
                  {extra ? (
                    <button
                      onClick={() => setMore(true)}
                      className={classes.more}
                    >
                      {showMore[locale]}
                    </button>
                  ) : null}
                </>
              )}
            </div>
            <div className={classes.ending}>
              <div className={classes.actions}>
                {actions ? (
                  <>
                    {actions.primary && (
                      <Button
                        primary
                        onClick={() => {
                          activateAction(actions.primary.action, title);
                        }}
                      >
                        {actions.primary.label}
                      </Button>
                    )}
                    {actions.secondary && (
                      <Button onClick={() => {}}>
                        {actions.secondary.label}
                      </Button>
                    )}
                  </>
                ) : null}
              </div>
              {flagTextElement}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Card.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  text: PropTypes.string.isRequired,
  actions: PropTypes.object,
  flagText: PropTypes.string,
  extra: PropTypes.object,
  locale: PropTypes.string,
};

export default Card;
